/* eslint-disable dot-notation */
/* eslint-disable wrap-iife */
/* eslint-disable import/extensions */
import $ from 'jquery';
import Blazy from 'blazy';
import 'slick-carousel/slick/slick.min.js';

import App from './modules/App';
import { AppInit } from './modules/Init';
import GetFunction, { Get } from './modules/Get';
import { LazyLoad } from './modules/LazyLoad';
import ScrollTop from './modules/ScrollTop';
import { Alert } from './modules/Alert';

const getHotspots = ({ Hotspots }) => {
  if (Hotspots.response) {
    Object.entries(Hotspots.response).forEach(([key, value]) => {
      const hotspot = $(`#${key}`);
      if (!value) {
        hotspot.remove();
        return false;
      }

      hotspot.replaceWith(value);
      hotspot.removeClass('--ajax');
      return false;
    });

    App.vars.hotspotsBlazy = new Blazy({
      offset: 0,
      container: '.hotspot .products',
      success: function bLazySuccesFunc(element) {
        setTimeout(() => {
          $(element).closest('.--skeleton').removeClass('--skeleton');
          $(element).parent().addClass('--loaded');
        }, 200);
      },
    });

    App.fn.splitFirm();
    
    if (typeof tmMultiHornet !== 'undefined') {
      tmMultiHornet('body');
    }
  }
};

const ioOptions = {
  rootMaring: '0px',
  treshhold: 0.5
}

const GetHotspots = new GetFunction();

const ioCallback = (entries) => {
  const { zonesNames, zonesTypes } = entries.filter(({ isIntersecting }) => isIntersecting).reduce((acc, curr) => {
    const { id, dataset } = curr.target;

    acc.zonesNames = [...acc.zonesNames, id];
    acc.zonesTypes = [...acc.zonesTypes, dataset.pagetype];

    return acc;
  }, {
    zonesNames: [],
    zonesTypes: [],
  });

  if (!zonesNames.length) return;

  GetHotspots.Hotspots(
    {
      zonesNames: zonesNames.join(','),
      components: zonesNames.join(','),
      zonesTypes: zonesTypes.join(','),
    },
    getHotspots,
  );
  GetHotspots.init();
}

App.run(
  () => {
    const observer = new IntersectionObserver(ioCallback, ioOptions);
    document.querySelectorAll('.hotspot.--ajax').forEach((element) => {
      observer.observe(element);
    });

    App.vars.lazyLoad = new LazyLoad(document.querySelector('#main_banner1'), {});
    App.vars.scrollTop = new ScrollTop();

    if (!document.querySelector('#main_banner1').classList.contains('--html')) {
      $('#main_banner1').removeClass('--skeleton');
      $('#main_banner1 .main_slider').slick({
        adaptiveHeight: false,
        dots: true,
        autoplaySpeed: 8000,
        autoplay: true,
        arrows: false,
      });
    } else {
      $('#main_banner1 .main_slider')
        .on('init', () => {
          $('#main_banner1 .slick-current .banner').addClass('--active');
        })
        .on('afterChange', (event, slick, currentSlide) => {
          $('#main_banner1 .banner.--active').removeClass('--active');
          $(slick['$slides'][currentSlide]).find('.banner').addClass('--active');
        })
        .slick({
          adaptiveHeight: true,
          dots: true,
          autoplaySpeed: 8000,
          autoplay: true,
          arrows: false,
        });
    }
  },
  'all',
  '#main_banner1',
);

App.run(() => {
  // eslint-disable-next-line no-restricted-globals
  const query = location.search;

  if (query.indexOf('register=complete') !== -1) {
    Alert.show({ text: window.Literals.registerSuccess, mod: '--success', duration: 3500 });
  }
}, 'all');

App.run(() => {
  window.addEventListener('load', () => {
    document.querySelector('.--preload').classList.toggle('--preload');
  });
}, 'all');

AppInit();
